import ReactGa from "react-ga";

export const initGA = (trackingID) => {
  ReactGa.initialize(trackingID);
};

export const PageView = () => {
  ReactGa.pageview(window.location.pathname + window.location.search);
};

export const Event = (category, action, label) => {
  ReactGa.event({
    category: category,
    action: action,
    label: label,
  });
};

export const addProduct = (product, quantity) =>
  ReactGa.ga("ec:addProduct", {
    id: product._id,
    name: product.product_name,
    category: product.product_category.category_name,
    price: product.product_price,
    quantity: quantity,
  });

export const checkout = (val) => {
  ReactGa.ga("create", "UA-205848017-1");
  ReactGa.ga("require", "ec");

  val.map((i) => {
    var product = i.product;
    var quantiy = i.quantiy;
    addProduct(product, quantiy);
    // ReactGa.ga("ec:addProduct", {
    //   id: product._id,
    //   name: product.product_name,
    //   category: product.product_category.category_name,
    //   // 'brand': product.brand,
    //   // 'variant':  product.variant,
    //   price: product.product_price,
    //   quantity: i.quantity,
    // });
  });
  ReactGa.ga("ec:setAction", "checkout", {
    step: 1,
    option: "Visa",
  });
};
export const addImpression = (i, index) => {
  ReactGa.ga("create", "UA-205848017-1");
  ReactGa.ga("require", "ec");

  ReactGa.ga("ec:addImpression", {
    id: i._id,
    name: i.product_name,
    category: i.product_category.category_name,
    // list: "Related Products",
    position: index,
  });
  ReactGa.ga("send", "pageview");
};

export const gaAddToCart = (product, quantity) => {
  ReactGa.ga("create", "UA-205848017-1");

  ReactGa.ga("require", "ec");
  addProduct(product, quantity);
  ReactGa.ga("ec:setAction", "add");
  ReactGa.ga("send", "event", "UX", "click", "add to cart"); // Send data using an event.
};

export const gaTransaction = (items, tID, revenue, tax, shipping) => {
  ReactGa.ga("create", "UA-205848017-1");
  ReactGa.ga("require", "ec");
  items.map((i) => addProduct(i.product, i.quantity));
  ReactGa.ga("ec:setAction", "purchase", {
    // Transaction details are provided in an actionFieldObject.
    id: tID, // (Required) Transaction id (string).
    // affiliation: "Google Store - Online", // Affiliation (string).
    revenue: revenue, // Revenue (number).
    tax: tax, // Tax (number).
    shipping: shipping, // Shipping (number).
    // coupon: "SUMMER2013", // Transaction coupon (string).
  });
  ReactGa.ga("send", "pageview");
};

export const gaAddDetail = (product, quantity) => {
  ReactGa.ga("require", "ec");
  addProduct(product, quantity);
  ReactGa.ga("ec:setAction", "detail");
};
export function gaRemoveFromCart(product, quantity) {
  ReactGa.ga("ec:addProduct", {
    id: product._id,
    name: product.product_name,
    quantity: quantity,
  });
  ReactGa.ga("ec:setAction", "remove");
  ReactGa.ga("send", "event", "UX", "click", "remove from cart");
}
